import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Global} from "../global";

@Component({
  selector: 'app-pdf-laudo-tecnico',
  templateUrl: './pdf-laudo-tecnico.component.html'
})
export class PdfLaudoTecnicoComponent {

  url = '';

  alturaTela;

  constructor(
    public global: Global,
    private route: ActivatedRoute
  ) {
    route.params.subscribe(params => {
      this.url = global.dominio_site+'/adm/laudos-tecnicos/'+params['id_laudo_tecnico']+'/pdf/?tk='+localStorage.getItem('token');
    });
    this.alturaTela = window.screen.availHeight - 250;
  }

}




// WEBPACK FOOTER //
// ./src/app/laudos-tecnicos/pdf-laudo-tecnico.component.ts